/* eslint-disable */
import axios from 'axios';
import { getLocalToken } from '../helper/storageHelper';

const appHostname = process.env.REACT_APP_BASE_API_URL ?? 'https://meya.co.th';

const client = axios.create({
  baseURL: appHostname,
});

export function getActiveAuthToken() {
  // 1. Check shop token (sessionStorage meya-token4 first, then localStorage with 24h TTL)
  try {
    const shopTokenStr = sessionStorage.getItem('meya-token4');
    if (shopTokenStr && shopTokenStr !== 'undefined') {
      const parsed = JSON.parse(shopTokenStr);
      if (parsed?.token && parsed.token !== '-' && parsed.token.length > 20) {
        return parsed.token;
      }
    }
  } catch (e) {}

  try {
    const localShopToken = getLocalToken('meya-token4');
    if (localShopToken && typeof localShopToken === 'object') {
      if (localShopToken.token && localShopToken.token !== '-' && localShopToken.token.length > 20) {
        return localShopToken.token;
      }
    }
  } catch (e) {}

  // 2. Check job token (sessionStorage job_token first, then localStorage with 24h TTL)
  try {
    const sessionJobToken = sessionStorage.getItem('job_token');
    if (sessionJobToken && sessionJobToken !== 'undefined' && sessionJobToken.length > 20) {
      return sessionJobToken;
    }
  } catch (e) {}

  try {
    const localJobToken = getLocalToken('job_token') || localStorage.getItem('meya_access_token');
    if (localJobToken && localJobToken !== 'undefined' && localJobToken.length > 20) {
      return localJobToken;
    }
  } catch (e) {}

  return '';
}

const attachAuthHeader = (config) => {
  if (!config.headers) {
    config.headers = {};
  }
  if (!config.headers.Authorization && !config.headers.authorization) {
    const token = getActiveAuthToken();
    if (token) {
      config.headers.Authorization = 'Bearer ' + token;
    }
  }
  return config;
};

const handleAuthError = (error) => {
  if (error?.response?.status === 401) {
    console.warn('[Auth] Received 401 Unauthorized from backend:', error.config?.url);
  }
  return Promise.reject(error);
};

client.interceptors.request.use(attachAuthHeader);
axios.interceptors.request.use(attachAuthHeader);

client.interceptors.response.use((res) => res, handleAuthError);
axios.interceptors.response.use((res) => res, handleAuthError);

export default client;
